import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

// Every date a request body carries targets a DateOnly or a TimeOnly server-side: a wall clock, with no
// time zone attached. JSON.stringify serialises a Date as a UTC instant instead ("2026-08-13T22:00:00.000Z"
// for the 14th at midnight in Brussels), which leaves the API resolving the day and the time in its own
// time zone: right on a developer machine (Europe/Brussels), one day off on Azure (UTC).
// An ISO string without offset carries the wall clock as-is, whatever the two time zones are.
function toWallClockIso(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    + `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

function isBinary(value: object): boolean {
  return value instanceof Blob || value instanceof ArrayBuffer || value instanceof FormData;
}

function toWallClock(value: unknown): unknown {
  if (value instanceof Date) return toWallClockIso(value);
  if (Array.isArray(value)) return value.map(toWallClock);
  if (value === null || typeof value !== 'object') return value;
  if (isBinary(value)) return value;

  const result: Record<string, unknown> = {};
  for (const key of Object.keys(value)) {
    result[key] = toWallClock((value as Record<string, unknown>)[key]);
  }
  return result;
}

export class WallClockBodyInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.body === null || typeof req.body !== 'object' || isBinary(req.body)) {
      return next.handle(req);
    }
    return next.handle(req.clone({body: toWallClock(req.body)}));
  }
}
